import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d829ab4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkInvoiceStatuses" }
const _hoisted_2 = {
  key: 0,
  class: "OkInvoiceStatuses__state"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "state__text mt-1" }, "Загрузка статусов...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "state__text text--failed" }, "При загрузке статусов произошла ошибка", -1))
const _hoisted_5 = {
  key: 2,
  class: "state__text"
}
const _hoisted_6 = {
  key: 1,
  class: "OkInvoiceStatuses__container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "status__icon",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "6",
    cy: "6",
    r: "6",
    fill: "currentColor"
  })
], -1))
const _hoisted_8 = { class: "status__information" }
const _hoisted_9 = { class: "information__title" }
const _hoisted_10 = {
  key: 0,
  class: "information__date"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_ok_button = _resolveComponent("ok-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading || _ctx.failed || _ctx.statuses.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_3
              ], 64))
            : (_ctx.failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createVNode(_component_ok_button, {
                    class: "mt-1",
                    type: "button",
                    onClick: _ctx.emitReload
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Обновить")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (_ctx.statuses.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Нет статусов"))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["container__status", { 'status--active': Boolean(status.date) }]),
              key: `InvoiceStatus-${i}`
            }, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(status.status_title), 1),
                (status.date || status.predict_date)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(status.date || status.predict_date), 1))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          }), 128))
        ]))
  ]))
}